import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {GoodsReceiptComponent} from "./ptp/goods-receipt/goods-receipt.component";
import {OrderMonitorComponent} from "./ptp/order-monitor/order-monitor.component";
import {PaymentComponent} from "./ptp/payment/payment.component";
import {AuditLogComponent} from "./ptp/audit-log/audit-log.component";
import {PoComponent} from "./ptp/po/po.component";
import {PrComponent} from "./ptp/pr/pr.component";
import {PtpFormsComponent} from "./ptp/ptp-forms/ptp-forms.component";
import {PoInvoiceComponent} from "./ptp/po-invoice/po-invoice.component";
import {PtpComponent} from "./ptp/ptp.component";
import {ARReportComponent} from "./report/arreport/arreport.component";
import {CustomersComponent} from "./report/arreport/customers/customers.component";
import {FINReportComponent} from "./report/finreport/finreport.component";
import {ScanDirectoryComponent} from "./configure/scan-directory/scan-directory.component";
import {ScanDirectoryEditComponent} from "./configure/scan-directory/scan-directory-edit/scan-directory-edit.component";
import {InternalSettingComponent} from "./configure/internal-setting/internal-setting.component";
import {PTPDepartmentComponent} from "./configure/ptp-department/ptp-department.component";
import {PTPDepartmentEditComponent} from "./configure/ptp-department/ptp-department-edit/ptp-department-edit.component";
import {PTPLocationComponent} from "./configure/ptp-location/ptp-location.component";
import {PTPLocationEditComponent} from "./configure/ptp-location/ptp-location-edit/ptp-location-edit.component";
import {PTPMetaDataMapComponent} from "./configure/ptp-metadata-map/ptp-metadata-map.component";
import {PTPMetaDataMapEditComponent} from "./configure/ptp-metadata-map/ptp-metadata-map-edit/ptp-metadata-map-edit.component";
import {PTPStepComponent} from "./configure/ptp-step/ptp-step.component";
import {PTPStepEditComponent} from "./configure/ptp-step/ptp-step-edit/ptp-step-edit.component";
import {EQConnectorKeyComponent} from "./configure/eq-connector-key/eq-connector-key.component";
import {LogsComponent} from "./configure/logs/logs.component";
import {InternalSettingEditComponent} from "./configure/internal-setting/internal-setting-edit/internal-setting-edit.component";
import {ProfileComponent} from "./profile/profile.component";
import {SearchComponent} from "./search/search.component";
import {AboutComponent} from "./about/about.component";
import {ManageIndexComponent} from "./configure/manage-index/manage-index.component";
import {UploadComponent} from "./upload/upload.component";
import {CustomerEditComponent} from "./report/arreport/customers/customer-edit/customer-edit.component";
import {UserComponent} from "./configure/user/user.component";
import {UserEditComponent} from "./configure/user/user-edit/user-edit.component";
import {GroupComponent} from "./configure/group/group.component";
import {GroupEditComponent} from "./configure/group/group-edit/group-edit.component";
import {KeywordComponent} from "./configure/keyword/keyword.component";
import {KeywordEditComponent} from "./configure/keyword/keyword-edit/keyword-edit.component";
import {DocumentEditComponent} from "./document/document-edit/document-edit.component";
import {DocumentTypeComponent} from "./configure/document-type/document-type.component";
import {DocumentTypeEditComponent} from "./configure/document-type/document-type-edit/document-type-edit.component";
import {ApComponent} from "./ap/ap.component";
import {ApLogComponent} from "./ap/ap-log/ap-log.component";
import {DXSettingsComponent} from "./tenant/dx-settings/dx-settings.component";
import {ApPreviewComponent} from "./ap/ap-preview/ap-preview.component";
import {ProcessScanComponent} from "./scan/process-scan/process-scan.component";
import {ApcheckSettingComponent} from "./configure/apcheck-setting/apcheck-setting.component";
import {ScanListComponent} from "./scan/scans/scans.component";
import {ErrorComponent} from "./error/error.component";
import {LoginComponent} from "./account/login/login.component";
import {ForgotPasswordComponent} from "./account/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./account/reset-password/reset-password.component";
import {AuthGuard} from "./services/auth.guard";
import {ZonalTemplateListComponent} from "./configure/zonal-template/zonal-template-list.component";
import {ConfigureLandingComponent} from "./configure/configure-landing/configure-landing.component";
import {ConsentComponent} from "./account/consent/consent.component";
import {AiSettingComponent} from "./configure/ai-setting/ai-setting.component";
import {ZonalTemplateEditComponent} from "./configure/zonal-template/zonal-template-edit.component";
import {ZonalTemplateCreateComponent} from "./configure/zonal-template/zonal-template-create/zonal-template-create.component";
import {ZonalTemplateFailedCreateComponent} from "./configure/zonal-template/zonal-template-failed-create/zonal-template-failed-create.component";

// public routes (no auth) sit before the guarded parent so they match first
const routes: Routes = [
    {path: "account/login", component: LoginComponent},
    {path: "account/forgot-password", component: ForgotPasswordComponent},
    {path: "account/reset-password", component: ResetPasswordComponent},
    {path: "error/:page", component: ErrorComponent},
    {path: "error", component: ErrorComponent},
    {
        path: "",
        canActivate: [AuthGuard],
        children: protectedRoutes()
    },
    // catch-all: unknown URLs render the 404 page instead of a blank screen
    {path: "**", redirectTo: "error/404"}
];

function protectedRoutes(): Routes {
    return [
    {path: "", redirectTo: "search", pathMatch: "full"},
    {path: "account/consent", component: ConsentComponent},
    {path: "ptp", component: PtpComponent},
    {path: "ptp/forms", component: PtpFormsComponent},
    {path: "ptp/poinvoice", component: PoInvoiceComponent},
    {path: "ptp/ordermonitor", component: OrderMonitorComponent},
    {path: "ptp/goodsreceipt", component: GoodsReceiptComponent},
    {path: "ptp/payment", component: PaymentComponent},
    {path: "ptp/auditlog", component: AuditLogComponent},
    {path: "search", component: SearchComponent},
    {path: "about", component: AboutComponent},
    {path: "profile/:tab", component: ProfileComponent},
    {path: "tenant/dxsettings", component: DXSettingsComponent},
    {path: "profile", component: ProfileComponent},
    {path: "scan/process", component: ProcessScanComponent},
    {path: "scan", component: ScanListComponent},
    {path: "scan/:tab", component: ScanListComponent},
    {path: "ptp/po", component: PoComponent},
    {path: "ptp/porequest", component: PrComponent},
    {path: "report/arreport", component: ARReportComponent},
    {path: "report/arreport/customers", component: CustomersComponent},
    {path: "report/arreport/customercreate", component: CustomerEditComponent},
    {path: "report/arreport/customeredit", component: CustomerEditComponent},
    {path: "report/finreport", component: FINReportComponent},
    {path: "configure", component: ConfigureLandingComponent},
    {path: "configure/aisetting", component: AiSettingComponent},
    {path: "configure/scandirectory", component: ScanDirectoryComponent},
    {path: "configure/scandirectoryedit", component: ScanDirectoryEditComponent},
    {path: "configure/scandirectorycreate", component: ScanDirectoryEditComponent},
    {path: "configure/internalsetting", component: InternalSettingComponent},
    {path: "configure/ptpdepartment", component: PTPDepartmentComponent},
    {path: "configure/ptpdepartmentcreate", component: PTPDepartmentEditComponent},
    {path: "configure/ptpdepartmentedit", component: PTPDepartmentEditComponent},
    {path: "configure/ptplocation", component: PTPLocationComponent},
    {path: "configure/ptplocationcreate", component: PTPLocationEditComponent},
    {path: "configure/ptplocationedit", component: PTPLocationEditComponent},
    {path: "configure/ptpmetadatamap", component: PTPMetaDataMapComponent},
    {path: "configure/ptpmetadatamapcreate", component: PTPMetaDataMapEditComponent},
    {path: "configure/ptpmetadatamapedit", component: PTPMetaDataMapEditComponent},
    {path: "configure/ptpstep", component: PTPStepComponent},
    {path: "configure/ptpstepcreate", component: PTPStepEditComponent},
    {path: "configure/ptpstepedit", component: PTPStepEditComponent},
    {path: "configure/eqconnectorkey", component: EQConnectorKeyComponent},
    {path: "configure/logs", component: LogsComponent},
    {path: "configure/internalsettingedit", component: InternalSettingEditComponent},
    {path: "configure/internalsettingcreate", component: InternalSettingEditComponent},
    {path: "configure/manageindex", component: ManageIndexComponent},
    {path: "configure/users", component: UserComponent},
    {path: "configure/usercreate", component: UserEditComponent},
    {path: "configure/useredit", component: UserEditComponent},
    {path: "configure/groups", component: GroupComponent},
    {path: "configure/groupcreate", component: GroupEditComponent},
    {path: "configure/groupedit", component: GroupEditComponent},
    {path: "configure/keywords", component: KeywordComponent},
    {path: "configure/keywordcreate", component: KeywordEditComponent},
    {path: "configure/keywordedit", component: KeywordEditComponent},
    {path: "configure/documenttypes", component: DocumentTypeComponent},
    {path: "configure/documenttypecreate", component: DocumentTypeEditComponent},
    {path: "configure/documenttypeedit", component: DocumentTypeEditComponent},
    {path: "configure/apchecksetting", component: ApcheckSettingComponent},
    {path: "upload", component: UploadComponent},
    {path: "document/documentedit", component: DocumentEditComponent},
    {path: "ap", component: ApComponent},
    {path: "ap/logs", component: ApLogComponent},
    {path: "ap/preview", component: ApPreviewComponent},
    {path: "configure/zonaltemplate", component: ZonalTemplateListComponent},
    {path: "configure/zonaltemplatecreate", component: ZonalTemplateCreateComponent},
    {path: "configure/zonaltemplateedit", component: ZonalTemplateEditComponent},
    {path: "configure/zonaltemplatefailedcreate", component: ZonalTemplateFailedCreateComponent}
    ];
}

@NgModule({
    imports: [RouterModule.forRoot(routes, {bindToComponentInputs: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
